import { useEffect, useRef } from 'react'

import { Play, Loader2 } from 'lucide-react'

import '../../workspace/css/workspace.scss'

export default function ReplayTerminal({ height, output = [], isRunning = false, runLabel = 'Run Tests' }) {
  const scrollRef = useRef(null)

  // Auto-scroll when output changes
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [output])

  return (
    <div className="ws-terminal-panel" style={{ height: `${height}px` }}>
      <div className="ws-terminal-controls">
        <div className="ws-controls-left">
          <button 
            className={`ws-run-button ${isRunning ? 'ws-running' : ''}`}
            disabled
            style={{ cursor: 'default', opacity: isRunning ? 0.7 : 1 }}
          >
            {isRunning ? (
              <>
                <Loader2 className="ws-icon-sm ws-spin" />
                Running...
              </>
            ) : (
              <>
                <Play className="ws-icon-sm" />
                {runLabel}
              </>
            )}
          </button>
        </div>
      </div>

      <div className="ws-terminal-output" ref={scrollRef}>
        <div className="ws-output-content">
          {output.length === 0 && !isRunning && (
            <span style={{ opacity: 0.5 }}>Waiting for execution...</span>
          )}
          {output.map((line, index) => (
            <div key={index} className={`terminal-line ${line.type}`}>
              {line.content}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}